import React, { useEffect, useMemo, useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { useLoadingCount } from '../../../loading/useLoadingCount';

function useDebouncedVisible(active, { delayMs = 150, minVisibleMs = 250 } = {}) {
  const [visible, setVisible] = useState(false);
  const state = useMemo(() => ({ showAt: 0 }), []);

  useEffect(() => {
    let t1;
    let t2;

    if (active) {
      t1 = window.setTimeout(() => {
        state.showAt = Date.now();
        setVisible(true);
      }, delayMs);
    } else {
      const elapsed = visible ? Date.now() - state.showAt : 0;
      const remaining = Math.max(0, minVisibleMs - elapsed);
      t2 = window.setTimeout(() => setVisible(false), remaining);
    }

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [active, delayMs, minVisibleMs, visible, state]);

  return visible;
}

export default function LoadingOverlay({ mode = 'nonBlocking' }) {
  const count = useLoadingCount();
  const active = count > 0;
  const visible = useDebouncedVisible(active);

  if (!visible) return null;

  const blocking = mode === 'blocking';

  return (
    <div className={`global-loading ${blocking ? 'is-blocking' : 'is-nonblocking'}`} aria-live="polite">
      <div className="global-loading__pill" role="status" aria-label="Loading">
        <ClipLoader size={18} color="var(--color-accent, #FF6D34)" />
        <span className="global-loading__text">Loading…</span>
      </div>
    </div>
  );
}

